import { useCallback } from "react";

import { useDispatch } from "react-redux";

import { setModalContext } from "actions";
import { ModalTypes } from "constants/navigation";
import { openSaleModal } from "lib/navigation";

import { useIsMobile } from "./useScreenSize";
import { useHasAlternativeMobileWorkflowPermission } from "./useHasPermission";

/**
 * Returns a callback for creating a new sale.
 * On mobile if the deployment/yard has alternative mobile workflow permission.
 * This opens the sale type picker first so the user can select a type
 * before the full sale creation modal opens.
 * On desktop, opens the sale creation modal directly (no change to existing behaviour).
 */
export function useOpenCreateSaleModal(): () => void {
  const isMobile = useIsMobile();
  const dispatch = useDispatch();

  const hasAlternativeMobileWorkflowPermission =
    useHasAlternativeMobileWorkflowPermission();

  return useCallback(() => {
    if (hasAlternativeMobileWorkflowPermission && isMobile) {
      dispatch(setModalContext(ModalTypes.SaleTypePicker, { isOpen: true }));
    } else {
      openSaleModal();
    }
  }, [isMobile, dispatch, hasAlternativeMobileWorkflowPermission]);
}
